/* First Sword theme.js — no dependencies. */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const routes = window.FS && window.FS.routes ? window.FS.routes : { cart_add: '/cart/add', cart_change: '/cart/change', cart: '/cart', root: '/' };
  const moneyFormat = (window.FS && window.FS.moneyFormat) || '${{amount}}';
  const STR = Object.assign({ added: 'Added to cart', couldNotAdd: 'Could not add', selectOption: 'Select __OPTION__', selectAnOption: 'Select an option', soldOut: 'Sold out' }, (window.FS && window.FS.strings) || {});
  const selectLabel = (name) => name ? STR.selectOption.replace('__OPTION__', name) : STR.selectAnOption;

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    const parts = value.split('.');
    const withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const amount = withCommas + '.' + parts[1];
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ',').replace(/,(?=\d{3})/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withCommas.replace(/,/g, '.'));
  }

  /* ---------------- Toast ---------------- */
  let toastTimer;
  function toast(title, desc) {
    const el = $('#Toast');
    if (!el) return;
    $('.toast__title', el).textContent = title || '';
    $('.toast__desc', el).textContent = desc || '';
    $('.toast__desc', el).hidden = !desc;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 2800);
  }
  window.FSToast = toast;

  /* ---------------- Cart ---------------- */
  const Cart = {
    drawer: null,
    init() {
      this.drawer = $('#CartDrawer');
      document.addEventListener('click', (e) => {
        const open = e.target.closest('[data-cart-open]');
        if (open && this.drawer) { e.preventDefault(); this.open(); return; }
        if (e.target.closest('[data-cart-close]')) { this.close(); return; }
        const change = e.target.closest('[data-line-change]');
        if (change) {
          const key = change.dataset.lineKey;
          const qty = parseInt(change.dataset.lineQty, 10);
          this.change(key, qty);
        }
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
    },
    open() {
      if (!this.drawer) return;
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      const closeBtn = $('[data-cart-close]', this.drawer);
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    },
    close() {
      if (!this.drawer || !this.drawer.classList.contains('is-open')) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },
    setLoading(on) { if (this.drawer) this.drawer.classList.toggle('is-loading', on); },
    async refresh() {
      const res = await fetch(`${routes.root}?sections=cart-drawer`, { headers: { Accept: 'application/json' } });
      const data = await res.json();
      if (data['cart-drawer'] && this.drawer) {
        const tmp = document.createElement('div');
        tmp.innerHTML = data['cart-drawer'];
        const fresh = $('#CartDrawer', tmp);
        if (fresh) {
          const wasOpen = this.drawer.classList.contains('is-open');
          this.drawer.innerHTML = fresh.innerHTML;
          if (wasOpen) this.drawer.classList.add('is-open');
        }
      }
      const cartRes = await fetch(`${routes.cart}.js`, { headers: { Accept: 'application/json' } });
      const cart = await cartRes.json();
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
      // Cart page (non-drawer) re-render
      const page = $('#CartPage');
      if (page) {
        const r = await fetch(`${routes.cart}?section_id=main-cart`);
        const html = await r.text();
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const fresh = $('#CartPage', tmp);
        if (fresh) page.innerHTML = fresh.innerHTML;
      }
      return cart;
    },
    async add(formData) {
      this.setLoading(true);
      const res = await fetch(`${routes.cart_add}.js`, { method: 'POST', body: formData, headers: { Accept: 'application/json' } });
      const data = await res.json();
      if (!res.ok) { this.setLoading(false); throw new Error(data.description || data.message || 'Could not add to cart'); }
      await this.refresh();
      this.setLoading(false);
      return data;
    },
    async change(key, quantity) {
      this.setLoading(true);
      await fetch(`${routes.cart_change}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      await this.refresh();
      this.setLoading(false);
    }
  };

  /* ---------------- Quick add (collection cards) ---------------- */
  function initQuickAdd() {
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn || btn.disabled || btn.classList.contains('is-busy')) return;
      e.preventDefault(); e.stopPropagation();
      btn.classList.add('is-busy');
      try {
        const fd = new FormData();
        fd.append('id', btn.dataset.quickAdd);
        fd.append('quantity', '1');
        if (btn.dataset.buyMode === 'checkout') { window.location.href = `${routes.cart}/${btn.dataset.quickAdd}:1`; return; }
        await Cart.add(fd);
        toast(STR.added, `${btn.dataset.title} · ${btn.dataset.value}`);
        if (Cart.drawer) Cart.open(); else window.location.href = routes.cart;
      } catch (err) {
        toast(STR.couldNotAdd, err.message);
      } finally {
        btn.classList.remove('is-busy');
      }
    });
  }

  /* ---------------- Product form ---------------- */
  function initProductForms() {
    $$('[data-product-form]').forEach((form) => {
      const variantsScript = $('[data-variants-json]', form.closest('[data-product]') || document);
      const variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
      const optionInputs = $$('[data-option-index]', form);
      const idInput = $('input[name="id"]', form);
      const submit = $('[data-add-to-cart]', form);
      const submitLabel = $('[data-add-to-cart-text]', form);
      const priceEl = $('[data-price]', form.closest('[data-product]') || document);
      const qtyInput = $('input[name="quantity"]', form);
      const defaultLabel = form.dataset.addText || 'Add to cart';
      const requireChoice = form.dataset.requireChoice === 'true';
      const selected = {};

      function currentVariant() {
        const keys = Object.keys(selected);
        if (keys.length === 0) return null;
        return variants.find((v) => keys.every((i) => v.options[parseInt(i, 10)] === selected[i])) || null;
      }
      const sticky = $('[data-sticky-atc]', form.closest('[data-product]') || document);
      function chosenLabel() {
        return Object.keys(selected)
          .filter((k) => optionInputs.filter((b) => b.dataset.optionIndex === k).length > 1)
          .map((k) => selected[k]).join(' · ');
      }
      function update() {
        const v = currentVariant();
        if (sticky) {
          const sp = $('[data-sticky-price]', sticky), sv = $('[data-sticky-variant]', sticky), sl = $('[data-sticky-label]', sticky), sb = $('[data-sticky-btn]', sticky);
          if (v && sp) sp.textContent = formatMoney(v.price);
          if (sv) { const lab = chosenLabel(); sv.textContent = lab ? ' · ' + lab : ''; }
          if (sl) { const pg = $$('[data-option-group]', form).find((g) => selected[g.dataset.optionGroup] === undefined); sl.textContent = v ? (v.available ? defaultLabel : (form.dataset.soldOutText || STR.soldOut)) : selectLabel(pg ? pg.dataset.optionName : ''); }
          if (sb) sb.disabled = !!(v && !v.available);
        }
        const allChosen = optionInputs.length === 0 || Object.keys(selected).length === optionInputs.filter((b, i, arr) => arr.findIndex((x) => x.dataset.optionIndex === b.dataset.optionIndex) === i).length;
        if (v) {
          idInput.value = v.id;
          if (submit) submit.classList.remove('is-pending');
          if (priceEl) {
            priceEl.innerHTML = v.compare_at_price && v.compare_at_price > v.price
              ? `<s>${formatMoney(v.compare_at_price)}</s>${formatMoney(v.price)}`
              : formatMoney(v.price);
          }
          if (submit) {
            submit.disabled = !v.available;
            if (submitLabel) submitLabel.textContent = v.available ? defaultLabel : (form.dataset.soldOutText || 'Sold out');
          }
        } else if (submit) {
          // No variant resolved yet: keep the button live and tell them what to pick.
          const pendingGroup = $$('[data-option-group]', form).find((g) => selected[g.dataset.optionGroup] === undefined);
          const pendingName = pendingGroup ? pendingGroup.dataset.optionName : 'option';
          submit.disabled = false;
          submit.classList.toggle('is-pending', requireChoice || !allChosen);
          if (submitLabel) submitLabel.textContent = (requireChoice || !allChosen) ? selectLabel(pendingName) : defaultLabel;
        }
        // mark unavailable sizes given other selections
        optionInputs.forEach((btn) => {
          const idx = btn.dataset.optionIndex;
          const val = btn.dataset.optionValue;
          const match = variants.find((vr) => vr.options[parseInt(idx, 10)] === val && Object.keys(selected).filter((k) => k !== idx).every((k) => vr.options[parseInt(k, 10)] === selected[k]));
          btn.classList.toggle('is-unavailable', !match || !match.available);
          btn.classList.toggle('is-selected', selected[idx] === val);
          btn.setAttribute('aria-pressed', selected[idx] === val ? 'true' : 'false');
        });
      }
      optionInputs.forEach((btn) => {
        if (btn.dataset.preselected === 'true') selected[btn.dataset.optionIndex] = btn.dataset.optionValue;
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          if (btn.classList.contains('is-unavailable')) return;
          selected[btn.dataset.optionIndex] = btn.dataset.optionValue;
          update();
        });
      });
      // Options that only have one value are implicitly selected
      const groups = {};
      optionInputs.forEach((b) => { (groups[b.dataset.optionIndex] = groups[b.dataset.optionIndex] || []).push(b); });
      Object.keys(groups).forEach((idx) => { if (groups[idx].length === 1) selected[idx] = groups[idx][0].dataset.optionValue; });
      if (!requireChoice && optionInputs.length === 0 && variants[0]) idInput.value = variants[0].id;
      update();

      $$('[data-qty-change]', form).forEach((btn) => {
        btn.addEventListener('click', () => {
          const delta = parseInt(btn.dataset.qtyChange, 10);
          const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
          qtyInput.value = next;
          const disp = $('[data-qty-display]', form);
          if (disp) disp.textContent = next;
        });
      });

      if (sticky) {
        const anchor = submit || form;
        const io = new IntersectionObserver((entries) => {
          const below = entries[0].boundingClientRect.top < 0; // scrolled past
          const show = !entries[0].isIntersecting && (below || entries[0].boundingClientRect.top > window.innerHeight);
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', String(!show));
          document.body.classList.toggle('has-sticky-atc', show);
        }, { threshold: 0 });
        io.observe(anchor);
        $('[data-sticky-btn]', sticky).addEventListener('click', () => {
          if (currentVariant()) { form.requestSubmit ? form.requestSubmit() : submit.click(); return; }
          const group = $('[data-option-group]', form) || form;
          group.scrollIntoView({ behavior: 'smooth', block: 'center' });
          group.classList.remove('is-nudge'); void group.offsetWidth; group.classList.add('is-nudge'); setTimeout(() => group.classList.remove('is-nudge'), 700);
        });
      }

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const v = currentVariant();
        if (!idInput.value || !v) {
          const pendingGroup = $$('[data-option-group]', form).find((g) => selected[g.dataset.optionGroup] === undefined) || $('[data-option-group]', form);
          if (pendingGroup) { pendingGroup.scrollIntoView({ behavior: 'smooth', block: 'center' }); pendingGroup.classList.remove('is-nudge'); void pendingGroup.offsetWidth; pendingGroup.classList.add('is-nudge'); setTimeout(() => pendingGroup.classList.remove('is-nudge'), 700); }
          return;
        }
        submit.disabled = true;
        const spin = $('[data-add-spinner]', form);
        if (spin) spin.hidden = false;
        if (submitLabel) submitLabel.textContent = form.dataset.addingText || 'Adding…';
        try {
          const fd = new FormData(form);
          if (form.dataset.buyMode === 'checkout') {
            window.location.href = `${routes.cart}/${idInput.value}:${fd.get('quantity') || 1}`;
            return;
          }
          const item = await Cart.add(fd);
          const optLabel = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
          toast(form.dataset.addedText || STR.added, optLabel ? `${item.product_title} · ${optLabel}` : item.product_title);
          if (Cart.drawer) Cart.open(); else window.location.href = routes.cart;
        } catch (err) {
          toast(STR.couldNotAdd, err.message);
        } finally {
          if (spin) spin.hidden = true;
          if (submitLabel) submitLabel.textContent = v && !v.available ? (form.dataset.soldOutText || 'Sold out') : defaultLabel;
          submit.disabled = false;
          update();
        }
      });
    });
  }

  /* ---------------- Accordions / dialogs / menus ---------------- */
  function initAccordions() {
    $$('[data-accordion-trigger]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.accordion__item');
        const group = btn.closest('[data-accordion]');
        const open = item.classList.contains('is-open');
        if (group && group.dataset.accordion === 'single') $$('.accordion__item', group).forEach((i) => { i.classList.remove('is-open'); $('[data-accordion-trigger]', i).setAttribute('aria-expanded', 'false'); });
        item.classList.toggle('is-open', !open);
        btn.setAttribute('aria-expanded', String(!open));
        const panel = $('.accordion__panel', item);
        if (panel) panel.setAttribute('aria-hidden', String(open));
      });
    });
  }
  function initDialogs() {
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-dialog-open]');
      if (opener) {
        const d = document.getElementById(opener.dataset.dialogOpen);
        if (d) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; const f = $('[data-dialog-close]', d); if (f) f.focus({ preventScroll: true }); }
        return;
      }
      const closer = e.target.closest('[data-dialog-close]');
      if (closer) {
        const d = closer.closest('.dialog');
        if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      $$('.dialog.is-open').forEach((d) => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
      document.body.style.overflow = '';
    });
  }
  function initMobileMenu() {
    const btn = $('.header__menu-btn[data-menu-toggle]');
    const menu = $('#MobileMenu');
    if (!btn || !menu) return;
    const set = (open) => {
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', String(!open));
      btn.setAttribute('aria-expanded', String(open));
      $('[data-icon-open]', btn).hidden = open;
      $('[data-icon-close]', btn).hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
      document.body.classList.toggle('menu-open', open);
    };
    btn.addEventListener('click', () => set(!menu.classList.contains('is-open')));
    $$('a, button', menu).forEach((el) => el.addEventListener('click', () => set(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && menu.classList.contains('is-open')) set(false); });
    window.matchMedia('(min-width: 768px)').addEventListener('change', (e) => { if (e.matches) set(false); });
  }
  function initPrivacy() {
    const bar = $('#PrivacyBar');
    if (!bar) return;
    const KEY = 'fs-privacy-choice';
    let choice = null;
    try { choice = localStorage.getItem(KEY); } catch (e) { /* ignore */ }
    if (!choice) bar.hidden = false;
    $$('[data-privacy]', bar).forEach((b) => b.addEventListener('click', () => {
      try { localStorage.setItem(KEY, b.dataset.privacy); } catch (e) { /* ignore */ }
      bar.hidden = true;
    }));
  }

  /* ---------------- Landing gate ---------------- */
  function initGate() {
    const gate = $('[data-gate]');
    if (!gate) return;

    // Clock
    const clock = $('[data-clock]', gate);
    if (clock) {
      const tz = clock.dataset.tz || undefined;
      const tzLabel = clock.dataset.tzLabel || '';
      const tick = () => {
        const now = new Date();
        const date = now.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric', timeZone: tz });
        const time = now.toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: tz });
        clock.textContent = `${date} · ${time}${tzLabel ? ' ' + tzLabel : ''}`;
      };
      tick();
      setInterval(tick, 1000);
    }

    // Hotspot placement relative to the cover-fitted background (image or video)
    const img = $('img.gate__bg', gate);
    const vid = $('video.gate__bg', gate);
    const hotspots = $$('[data-hotspot]', gate);
    function natural() {
      if (vid && vid.videoWidth) return [vid.videoWidth, vid.videoHeight];
      if (img && img.naturalWidth) return [img.naturalWidth, img.naturalHeight];
      return null;
    }
    function place() {
      const n = natural();
      if (!n || !hotspots.length) return;
      const W = gate.clientWidth, H = gate.clientHeight;
      const scale = Math.max(W / n[0], H / n[1]);
      const w = n[0] * scale, h = n[1] * scale;
      const left = (W - w) / 2, top = (H - h) / 2;
      hotspots.forEach((hs) => {
        const x = parseFloat(hs.dataset.x) / 100, y = parseFloat(hs.dataset.y) / 100;
        hs.style.left = `${left + x * w}px`;
        hs.style.top = `${top + y * h}px`;
      });
    }
    if (img) { if (img.complete) place(); else img.addEventListener('load', place, { once: true }); }
    if (vid) { vid.addEventListener('loadedmetadata', place, { once: true }); vid.play && vid.play().catch(() => {}); }
    new ResizeObserver(place).observe(gate);

    // Lantern cursor (fine pointers only)
    const lantern = $('.lantern', gate);
    const flame = $('.lantern__flame', gate);
    const light = $('.lantern-light', gate);
    const finePointer = window.matchMedia('(pointer: fine)');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (lantern && finePointer.matches && !reduce.matches) {
      gate.classList.add('has-cursor');
      let tx = 0, ty = 0, x = 0, y = 0, px = 0, py = 0, vx = 0, vy = 0, started = false;
      gate.addEventListener('pointermove', (e) => {
        tx = e.clientX; ty = e.clientY;
        if (!started) { x = tx; y = ty; px = tx; py = ty; started = true; gate.classList.add('is-pointing'); }
      }, { passive: true });
      gate.addEventListener('pointerleave', () => gate.classList.remove('is-pointing'));
      gate.addEventListener('pointerenter', () => { if (started) gate.classList.add('is-pointing'); });
      const loop = () => {
        const k = 0.28;
        x += (tx - x) * k; y += (ty - y) * k;
        vx = vx * 0.72 + (x - px) * 0.28; vy = vy * 0.72 + (y - py) * 0.28;
        px = x; py = y;
        const tilt = Math.max(-22, Math.min(22, -vx * 1.4));
        const speed = Math.min(1, Math.hypot(vx, vy) / 22);
        lantern.style.transform = `translate3d(${x}px, ${y}px, 0) translate(-50%, -85%)`;
        if (flame) {
          flame.style.setProperty('--tilt', `${tilt}deg`);
          flame.style.setProperty('--intensity', String(0.55 + speed * 0.9));
          flame.style.animationDuration = `${(0.7 - speed * 0.45).toFixed(3)}s`;
        }
        if (light) { light.style.setProperty('--x', `${x}px`); light.style.setProperty('--y', `${y}px`); }
        requestAnimationFrame(loop);
      };
      requestAnimationFrame(loop);
    } else if (lantern) {
      lantern.remove();
      if (light) light.remove();
    }
  }

  /* ---------------- Header: hide on scroll down, reveal + compact on scroll up ---------------- */
  function initHeader() {
    const header = $('[data-header]');
    if (!header || header.dataset.bound) return;
    header.dataset.bound = '1';
    const mode = header.dataset.sticky;
    if (mode === 'none') return;
    let last = window.scrollY;
    let ticking = false;
    const threshold = () => header.offsetHeight + 40;
    const apply = () => {
      const y = window.scrollY;
      const delta = y - last;
      const scrolled = y > threshold();
      header.classList.toggle('is-scrolled', scrolled);
      if (mode === 'scroll-up') {
        if (!scrolled) header.classList.remove('is-hidden');
        else if (delta > 4) header.classList.add('is-hidden');
        else if (delta < -4) header.classList.remove('is-hidden');
      }
      last = y;
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(apply); } }, { passive: true });
    apply();
  }

  /* ---------------- Product gallery ---------------- */
  function initGalleries() {
    $$('[data-gallery]').forEach((g) => {
      if (g.dataset.ready) return; g.dataset.ready = '1';
      const track = $('[data-gallery-track]', g);
      const slides = $$('[data-gallery-slide]', g);
      if (!track || slides.length < 2) return;
      const dots = $$('[data-gallery-to]', g);
      const prev = $('[data-gallery-prev]', g), next = $('[data-gallery-next]', g);
      let index = 0;
      const setActive = (i) => {
        index = Math.max(0, Math.min(slides.length - 1, i));
        dots.forEach((d) => d.classList.toggle('is-active', parseInt(d.dataset.galleryTo, 10) === index));
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === slides.length - 1;
      };
      const goTo = (i) => { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); setActive(i); };
      dots.forEach((d) => d.addEventListener('click', () => goTo(parseInt(d.dataset.galleryTo, 10))));
      if (prev) prev.addEventListener('click', () => goTo(index - 1));
      if (next) next.addEventListener('click', () => goTo(index + 1));
      let t;
      track.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => setActive(Math.round(track.scrollLeft / track.clientWidth)), 80); }, { passive: true });
      track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') goTo(index + 1); if (e.key === 'ArrowLeft') goTo(index - 1); });
      track.tabIndex = 0;
      setActive(0);
    });
  }

  /* ---------------- Countdown ---------------- */
  // Wall-clock time in an IANA zone -> UTC ms (handles DST by measuring the zone's offset at that instant).
  function zonedToUtc(y, m, d, h, mi, tz) {
    const guess = Date.UTC(y, m - 1, d, h, mi, 0);
    const fmt = new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' });
    const parts = Object.fromEntries(fmt.formatToParts(new Date(guess)).filter((p) => p.type !== 'literal').map((p) => [p.type, parseInt(p.value, 10)]));
    const asIfUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
    return guess - (asIfUtc - guess);
  }
  function initCountdowns() {
    $$('[data-countdown], [data-countdown-parts]').forEach((el) => {
      if (el.dataset.bound) return; el.dataset.bound = '1';
      let target;
      if (el.hasAttribute('data-countdown-parts')) {
        const y = +el.dataset.y, m = +el.dataset.m, d = +el.dataset.d, h = +el.dataset.h, mi = +el.dataset.min;
        try { target = new Date(zonedToUtc(y, m, d, h, mi, el.dataset.tz || 'UTC')); } catch (e) { target = new Date(y, m - 1, d, h, mi); }
      } else {
        const raw = (el.dataset.countdown || '').trim();
        const mm = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?(?:\s*([+-]\d{2}):?(\d{2}))?$/);
        if (!mm) return;
        if (mm[6]) target = new Date(`${mm[1]}-${mm[2]}-${mm[3]}T${mm[4] || '00'}:${mm[5] || '00'}:00${mm[6]}:${mm[7]}`);
        else target = new Date(+mm[1], +mm[2] - 1, +mm[3], +(mm[4] || 0), +(mm[5] || 0));
      }
      if (!target || isNaN(target)) return;
      const nums = { days: $('[data-cd="days"]', el), hours: $('[data-cd="hours"]', el), minutes: $('[data-cd="minutes"]', el), seconds: $('[data-cd="seconds"]', el) };
      const ended = $('.countdown__ended', el);
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        let diff = target - Date.now();
        if (diff <= 0) {
          el.classList.add('is-ended');
          if (el.dataset.hideEnded === 'true') { el.hidden = true; return; }
          if (ended && el.dataset.ended) { ended.textContent = el.dataset.ended; ended.hidden = false; }
          return;
        }
        const d = Math.floor(diff / 864e5); diff -= d * 864e5;
        const h = Math.floor(diff / 36e5); diff -= h * 36e5;
        const mi = Math.floor(diff / 6e4); diff -= mi * 6e4;
        const se = Math.floor(diff / 1e3);
        nums.days.textContent = pad(d); nums.hours.textContent = pad(h); nums.minutes.textContent = pad(mi); nums.seconds.textContent = pad(se);
        setTimeout(tick, 1000 - (Date.now() % 1000));
      };
      tick();
    });
  }

  /* ---------------- Localization picker ---------------- */
  function initLocalization() {
    $$('[data-localization-select]').forEach((sel) => {
      if (sel.dataset.bound) return; sel.dataset.bound = '1';
      sel.addEventListener('change', () => sel.form && sel.form.submit());
    });
  }

  /* ---------------- Page transitions (fallback when the browser lacks cross-document view transitions) ---------------- */
  function initPageTransitions() {
    const cfg = (window.FS && window.FS.transition) || { type: 'blur', ms: 300 };
    if (cfg.type === 'none') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const supportsCross = 'CSSViewTransitionRule' in window;
    if (supportsCross) return; // CSS @view-transition handles it natively
    const html = document.documentElement;
    html.classList.add('pt-fallback');
    if (cfg.type === 'fade') html.setAttribute('data-fade', '');
    document.body.classList.add('pt-entering');
    requestAnimationFrame(() => requestAnimationFrame(() => document.body.classList.remove('pt-entering')));
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download') || a.hasAttribute('data-cart-open') || a.hasAttribute('data-no-transition')) return;
      const href = a.getAttribute('href') || '';
      if (/^(mailto|tel|javascript):|^#/.test(href)) return;
      const url = new URL(a.href, location.href);
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
      e.preventDefault();
      document.body.classList.add('pt-leaving');
      setTimeout(() => { location.href = url.href; }, cfg.ms);
    });
    window.addEventListener('pageshow', (e) => { if (e.persisted) document.body.classList.remove('pt-leaving', 'pt-entering'); });
  }

  /* ---------------- Heading write-in ---------------- */
  function initWriteIn() {
    const cfg = (window.FS && window.FS.writeIn) || { enabled: true, speed: 50, body: true };
    if (!cfg.enabled || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let sel = '.eyebrow, .page__title, .banner__title, .product__title, .cart-page__title, .faq__group, .dialog__title, .gate__logo-text, .card__title';
    if (cfg.body) sel += ', .story__tagline, .banner__subtitle, .gate__clock-static';
    const targets = $$(sel).filter((el) => !el.dataset.wi && el.children.length === 0 && el.textContent.trim().length > 0 && el.textContent.trim().length <= 120);
    if (!targets.length) return;
    const split = (el) => {
      const text = el.textContent;
      el.setAttribute('aria-label', text.trim());
      el.dataset.wi = '1';
      el.classList.add('write-in');
      el.style.setProperty('--wi-speed', `${cfg.speed}ms`);
      const frag = document.createDocumentFragment();
      let i = 0;
      for (const ch of Array.from(text)) {
        const span = document.createElement('span');
        span.setAttribute('aria-hidden', 'true');
        if (ch === ' ') { span.className = 'wi-space'; span.textContent = ' '; }
        else { span.className = 'wi-char'; span.textContent = ch; span.style.setProperty('--i', i++); }
        frag.appendChild(span);
      }
      el.textContent = '';
      el.appendChild(frag);
      const total = i * cfg.speed + 600;
      el.dataset.wiTotal = total;
    };
    targets.forEach(split);
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        const el = en.target;
        io.unobserve(el);
        el.classList.add('is-writing');
        setTimeout(() => { el.classList.add('is-done'); el.classList.remove('is-writing'); }, parseInt(el.dataset.wiTotal, 10) || 1500);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -5% 0px' });
    targets.forEach((el) => io.observe(el));
  }

  /* ---------------- Boot ---------------- */
  document.addEventListener('DOMContentLoaded', () => {
    // After a newsletter/contact submit Shopify appends #contact_form; don't let it jump the page.
    if (/^#(contact_form|PasswordSignup)$/.test(location.hash)) {
      history.replaceState(null, '', location.pathname + location.search);
      requestAnimationFrame(() => window.scrollTo(0, 0));
    }
    initPageTransitions();
    initWriteIn();
    Cart.init();
    initHeader();
    initLocalization();
    initQuickAdd();
    initProductForms();
    initAccordions();
    initDialogs();
    initMobileMenu();
    initPrivacy();
    initGate();
    initCountdowns();
    initGalleries();
  });

  // Theme editor: re-init when sections load
  document.addEventListener('shopify:section:load', () => { initHeader(); initLocalization(); initWriteIn(); initProductForms(); initAccordions(); initGate(); initCountdowns(); initGalleries(); });
})();
